module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "BTspace ParaOverride-1"
  }, [_vm._v("Also by Sayaka Murata")]), _vm._v(" "), _c('p', {
    staticClass: "BTspace ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Convenience Store Woman")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50728afd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021570271.vue
// module id = 66
// module chunks = 0